import React from "react";

const StockEditSupplierScreen = () => {
  return <div>StockEditSupplierScreen</div>;
};

export default StockEditSupplierScreen;
